export class TakeSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "isPitrOnDemand",
            "baseName": "isPitrOnDemand",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "vaultStorageTier",
            "baseName": "vaultStorageTier",
            "type": "VaultStorageTier",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TakeSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
